var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1.367C4.5 1.95181 4.05 2.43029 3.5 2.43029H2.5V15.1898H3.5C4.05 15.1898 4.5 15.6683 4.5 16.2531C4.5 16.8379 4.05 17.3164 3.5 17.3164H1.5C0.95 17.3164 0.5 16.8379 0.5 16.2531V1.367C0.5 0.782192 0.95 0.303711 1.5 0.303711H3.5C4.05 0.303711 4.5 0.782192 4.5 1.367ZM14.504 3.94513L17.318 8.1983C17.568 8.5747 17.56 9.07977 17.3 9.44766L14.3 13.7008C14.104 13.9794 13.803 14.1261 13.499 14.1261C13.291 14.1261 13.08 14.057 12.9 13.9135C12.458 13.5615 12.369 12.8949 12.7 12.4259L14.501 9.87298H14.5H6.5C5.948 9.87298 5.5 9.39769 5.5 8.80969C5.5 8.22169 5.948 7.7464 6.5 7.7464H14.5C14.5165 7.7464 14.5318 7.75124 14.5473 7.75612C14.5599 7.7601 14.5725 7.76411 14.586 7.76554L12.868 5.16792C12.55 4.68837 12.659 4.02488 13.111 3.68675C13.562 3.34756 14.186 3.46453 14.504 3.94513Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8c2c69be96d0f04d9f134daac0ac1b80.svg";
export { ForwardRef as ReactComponent };